import {SLIDER, MEDIA} from "../../constants";

export const initWindow = (isScrollDirectionDown) => {
	if (window.innerWidth >= MEDIA.DESKTOP)
	{
		const currentSlide = SLIDER.HEADER_ANCHORS.find((anchor) => anchor.classList.contains(`current`));
		const currentSlideIndex = SLIDER.HEADER_ANCHORS.indexOf(currentSlide);
		const nextSlide = currentSlideIndex === -1 ? false : currentSlideIndex + 1 <= SLIDER.HEADER_ANCHORS.length - 1 && isScrollDirectionDown ? SLIDER.HEADER_ANCHORS[currentSlideIndex + 1] : currentSlideIndex - 1 >= 0 && !isScrollDirectionDown ? SLIDER.HEADER_ANCHORS[currentSlideIndex - 1] : false;

		nextSlide ? nextSlide.click() : false;
	}
};
